// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { HttpClientInstance } from '@toggl/sync/http';
import type {
  SubscriptionsApplyPromoCodeRequest,
  SubscriptionsCustomer,
  SubscriptionsIntent,
  SubscriptionsInvoices,
  SubscriptionsInvoiceSummary,
  SubscriptionsMutateCustomerRequest,
  SubscriptionsSubscription,
  SubscriptionsUpdateSubscriptionRequest,
} from '../types';
import { buildSearchParams } from '../utils/requests';

export async function getSubscription(
  httpClient: HttpClientInstance,
  workspace_id: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(`workspaces/${workspace_id}/subscriptions`, { signal })
    .json<SubscriptionsSubscription>();
  return response;
}

export async function putSubscription(
  httpClient: HttpClientInstance,
  workspace_id: number,
  data: SubscriptionsUpdateSubscriptionRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .put(`workspaces/${workspace_id}/subscriptions`, { signal, json: data })
    .json<unknown>();
  return response;
}

export async function deleteSubscription(
  httpClient: HttpClientInstance,
  workspace_id: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .delete(`workspaces/${workspace_id}/subscriptions`, { signal })
    .json<unknown>();
  return response;
}

export async function getCustomer(
  httpClient: HttpClientInstance,
  workspace_id: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(`workspaces/${workspace_id}/subscriptions/customer`, { signal })
    .json<SubscriptionsCustomer>();
  return response;
}

export async function putCustomer(
  httpClient: HttpClientInstance,
  workspace_id: number,
  data: SubscriptionsMutateCustomerRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .put(`workspaces/${workspace_id}/subscriptions/customer`, {
      signal,
      json: data,
    })
    .json<SubscriptionsCustomer>();
  return response;
}

export async function postCustomer(
  httpClient: HttpClientInstance,
  workspace_id: number,
  data: SubscriptionsMutateCustomerRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(`workspaces/${workspace_id}/subscriptions/customer`, {
      signal,
      json: data,
    })
    .json<SubscriptionsCustomer>();
  return response;
}

export async function getCustomerInvoices(
  httpClient: HttpClientInstance,
  workspace_id: number,
  {
    lastInvoiceId,
    nextInvoiceID,
  }: { lastInvoiceId?: string; nextInvoiceID?: string } = {},
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(`workspaces/${workspace_id}/subscriptions/customer/invoices`, {
      signal,
      searchParams: buildSearchParams({ lastInvoiceId, nextInvoiceID }),
    })
    .json<SubscriptionsInvoices>();
  return response;
}

export async function postSetupIntent(
  httpClient: HttpClientInstance,
  workspace_id: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(`workspaces/${workspace_id}/subscriptions/intent`, { signal })
    .json<SubscriptionsIntent>();
  return response;
}

export async function getInvoiceSummary(
  httpClient: HttpClientInstance,
  workspace_id: number,
  { subscriptionPlan }: { subscriptionPlan?: string } = {},
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(`workspaces/${workspace_id}/subscriptions/invoiceSummary`, {
      signal,
      searchParams: buildSearchParams({ subscriptionPlan }),
    })
    .json<SubscriptionsInvoiceSummary>();
  return response;
}

export async function postSubscriptionPromoCode(
  httpClient: HttpClientInstance,
  workspace_id: number,
  data: SubscriptionsApplyPromoCodeRequest,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(`workspaces/${workspace_id}/subscriptions/promoCode`, {
      signal,
      json: data,
    })
    .json<unknown>();
  return response;
}

export async function deleteSubscriptionPromoCode(
  httpClient: HttpClientInstance,
  workspace_id: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .delete(`workspaces/${workspace_id}/subscriptions/promoCode`, { signal })
    .json<unknown>();
  return response;
}
